export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  image: string;
  imageAlt: string;
  date: string;
  author: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: "hana-ikusa",
    title: "《花战》——苍井优以花为剑的绝美演绎",
    excerpt: "苍井优在电影《花战》中展现了令人惊叹的演技深度。这部以日本花道为背景的时代剧，让苍井优将角色内心的坚韧与柔美完美融合，成为她演艺生涯中不可忽视的代表作。",
    content: `<p>在2017年上映的《花战》（花戦さ）中，苍井优饰演了花僧池坊专好的妻子——一位在乱世中以花为武器、守护信仰与和平的女性。这部电影改编自鬼冢忠的同名小说，由筱原哲雄执导，讲述了战国时代京都六角堂的僧侣池坊专好，通过花道的力量来感化织田信长的故事。</p>
    <p>苍井优在片中的表演堪称教科书级别。她将角色内心的恐惧、坚韧与柔情层层递进地展现出来。在那些无声的镜头中，仅仅通过眼神和微妙的肢体语言，就能让观众感受到角色丰富的情感世界。尤其是她在花道场景中的专注神情，仿佛花朵本身就是她灵魂的延伸。</p>
    <p>影片中，苍井优与野村万斋、市川猿之助等实力派演员的对手戏也毫不逊色。她以一种近乎禅意的方式处理角色的情感转折，让整部作品的艺术质感得到了极大提升。《花战》不仅是苍井优演艺生涯中的一座里程碑，也向世人展示了她作为演员的无限可能性。</p>
    <p>评论界对苍井优在《花战》中的表现给予了高度评价。《电影旬报》称她"在沉默中爆发出惊人的力量"，而《读卖新闻》则赞扬她"将日本传统女性的内敛之美演绎到了极致"。这部电影也让她获得了第41届日本电影学院奖最佳女主角提名。</p>`,
    category: "film",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20Yu%20Aoi%20in%20traditional%20kimono%20holding%20flowers%2C%20soft%20cinematic%20lighting%2C%20elegant%20Japanese%20aesthetic%2C%20minimalist%20composition%2C%20warm%20natural%20tones%2C%20film%20photography%20style%2C%20ethereal%20atmosphere&width=800&height=450&seq=hana-ikusa&orientation=landscape",
    imageAlt: "苍井优在电影《花战》中的剧照",
    date: "2025-12-15",
    author: "编辑部",
    tags: ["花战", "电影作品", "时代剧", "演技", "代表作"],
    featured: true,
  },
  {
    id: "hula-girls",
    title: "《扶桑花女孩》——从青涩到成熟的蜕变之作",
    excerpt: "2006年的《扶桑花女孩》是苍井优演艺生涯的重要转折点。她在片中饰演的纪美子，从一个内向的少女成长为自信的舞者，苍井优凭借此片一举斩获多项新人奖和最佳女配角奖。",
    content: `<p>《扶桑花女孩》（フラガール）是2006年上映的日本电影，由李相日执导。影片基于真实故事改编，讲述了1960年代福岛县磐城市的一群年轻女孩，在日本经济转型期学习夏威夷草裙舞，最终在常磐夏威夷中心大获成功的故事。</p>
    <p>苍井优在片中饰演纪美子，一个失去母亲、与祖母相依为命的少女。起初她性格内向、不善言辞，但在学习草裙舞的过程中，逐渐找到了自信和生活的方向。苍井优对这个角色的诠释令人动容——她用极其细腻的表演捕捉了角色成长的每一个微小瞬间。</p>
    <p>影片高潮部分的舞蹈场景是苍井优演技的集中展示。她在舞台上挥洒汗水、笑容灿烂的模样，与影片初期那个沉默寡言的女孩形成了鲜明对比。这种反差不是靠台词堆砌出来的，而是通过苍井优日积月累的表演细节自然呈现的。</p>
    <p>凭借在《扶桑花女孩》中的出色表现，苍井优获得了第30届日本电影学院奖最佳女配角奖、第31届报知电影奖最佳女配角奖，以及第49届蓝丝带奖最佳女主角奖等多项殊荣。这部电影不仅奠定了她在日本电影界的地位，也让她成为了家喻户晓的实力派女演员。</p>`,
    category: "film",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20Yu%20Aoi%20dancing%20hula%20on%20stage%2C%20warm%20vintage%20color%20palette%2C%201960s%20Japanese%20retro%20aesthetic%2C%20soft%20nostalgic%20lighting%2C%20elegant%20composition%2C%20cinematic%20photography&width=800&height=450&seq=hula-girls&orientation=landscape",
    imageAlt: "苍井优在《扶桑花女孩》中的剧照",
    date: "2025-11-20",
    author: "编辑部",
    tags: ["扶桑花女孩", "电影作品", "获奖", "草裙舞", "代表作"],
    featured: true,
  },
  {
    id: "ryusei-wagon",
    title: "《流星旅行车》——苍井优的电视荧幕巅峰",
    excerpt: "在日剧《流星旅行车》中，苍井优以精湛的演技塑造了一个令人难以忘怀的角色。这部剧不仅刷新了收视纪录，也让苍井优的表演获得了业界的一致赞誉。",
    content: `<p>《流星旅行车》（流星ワゴン）是2015年TBS电视台播出的日剧，改编自重松清的同名小说。该剧由福泽克雄执导，西岛秀俊、香川照之、苍井优等主演。故事讲述了一个遭遇人生困境的中年男子，通过一辆神秘的旅行车穿越时空，与年轻时的父亲相遇的奇幻故事。</p>
    <p>苍井优在剧中饰演男主角的妻子，一个在家庭压力下濒临崩溃的女性角色。她精准地捕捉到了角色内心的脆弱与坚韧——一方面是对丈夫的失望和对婚姻的绝望，另一方面是为了孩子而强撑的母爱。这种复杂的情感层次被苍井优演绎得入木三分。</p>
    <p>特别值得一提的是剧中几场情感爆发的戏份。苍井优在那些场景中展现出的情绪张力让人屏息——她的哭泣不是夸张的嚎啕，而是压抑到极致的无声泪流，这种克制的表达方式反而更加震撼人心。日本评论界称赞她"用最少的表情传达了最多的情感"。</p>
    <p>《流星旅行车》播出后取得了极高的收视率和口碑。苍井优凭借此剧获得了第86届日剧学院赏最佳女配角奖，以及2015年TV LIFE年度日剧大赏最佳女配角奖。这部剧也让她在电视领域的地位得到了进一步巩固。</p>`,
    category: "drama",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20Yu%20Aoi%20emotional%20drama%20scene%2C%20soft%20natural%20lighting%2C%20minimalist%20Japanese%20interior%2C%20warm%20earthy%20tones%2C%20cinematic%20composition%2C%20elegant%20atmosphere&width=800&height=450&seq=ryusei-wagon&orientation=landscape",
    imageAlt: "苍井优在《流星旅行车》中的剧照",
    date: "2025-10-08",
    author: "编辑部",
    tags: ["流星旅行车", "电视剧", "日剧", "演技", "获奖"],
    featured: false,
  },
  {
    id: "farewell-poem",
    title: "《告别之诗》——舞台上的灵魂独白",
    excerpt: "苍井优在舞台剧《告别之诗》中展现了超凡的舞台掌控力。两个小时的独角戏，她用声音、肢体和情感征服了所有观众，成为当年最受瞩目的舞台作品之一。",
    content: `<p>《告别之诗》（別れの詩）是2019年在东京新国立剧场上演的一部独角戏舞台剧，由知名剧作家野田秀树执笔并执导。这部作品讲述了一位女性在生命最后时刻回顾一生的心路历程，是对生命、死亡和爱的深刻思考。</p>
    <p>对于任何演员来说，独角戏都是最大的挑战——没有对手演员可以依靠，没有转场可以喘息，舞台上的一切都取决于演员个人的表现力。苍井优在《告别之诗》中的表演令人叹为观止。在两个小时的演出中，她独自一人完成了从少女到老妇的跨越六十年的角色转换。</p>
    <p>苍井优在舞台上展现出了极强的身体控制力和声音变化能力。从少女的轻盈步伐到老妇的蹒跚步履，从青春洋溢的清脆嗓音到垂暮之年的沙哑低语，每一个细节都经过了精心的设计和反复的打磨。观众仿佛不是在看一场演出，而是真实地经历了一个人的一生。</p>
    <p>《告别之诗》的演出场场爆满，东京的演出门票在开售后三分钟内即告售罄。戏剧评论家们一致认为，这是苍井优演艺生涯中最具挑战性、也最成功的角色之一。她凭借这部作品获得了第27届读卖戏剧大奖最佳女演员奖，这是日本戏剧界的最高荣誉之一。</p>`,
    category: "stage",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20on%20dark%20theater%20stage%2C%20dramatic%20spotlight%2C%20minimalist%20stage%20design%2C%20powerful%20solitary%20performance%2C%20warm%20golden%20spotlight%2C%20atmospheric%20theater%20photography&width=800&height=450&seq=farewell-poem&orientation=landscape",
    imageAlt: "苍井优在舞台剧《告别之诗》中的演出照片",
    date: "2025-09-12",
    author: "编辑部",
    tags: ["告别之诗", "舞台剧", "独角戏", "戏剧", "获奖"],
    featured: true,
  },
  {
    id: "japan-academy-award",
    title: "苍井优斩获日本电影学院奖最佳女主角",
    excerpt: "在第48届日本电影学院奖颁奖典礼上，苍井优凭借在电影中的出色表现荣获最佳女主角奖。这是对她多年来在电影领域辛勤耕耘的最高肯定。",
    content: `<p>在第48届日本电影学院奖颁奖典礼上，苍井优以一身优雅的黑色长裙亮相红毯。当颁奖嘉宾念出她的名字时，现场响起了雷鸣般的掌声。这一刻，是对她二十余年演艺生涯最好的褒奖。</p>
    <p>苍井优在获奖感言中表示："能够获得这个奖项，我感到无比荣幸。演戏是我生命中最重要的事情，每一个角色都让我学到了新的东西。感谢所有与我合作的导演、演员和工作人员，是你们让我成为了更好的演员。"</p>
    <p>日本电影学院奖被誉为"日本的奥斯卡"，是日本电影界最具权威性的奖项之一。苍井优此前曾多次获得该奖项的提名，包括最佳女配角和最佳女主角类别，此次终于将最佳女主角奖杯收入囊中。</p>
    <p>评审委员会在评语中写道："苍井优的表演超越了语言的界限。她用眼神、呼吸和每一个细微的动作讲述故事，让角色变成了有血有肉的真实存在。她是日本电影的瑰宝。"</p>`,
    category: "awards",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20accepting%20award%20on%20stage%2C%20elegant%20black%20dress%2C%20golden%20spotlight%2C%20ceremony%20atmosphere%2C%20graceful%20pose%2C%20warm%20stage%20lighting%2C%20professional%20photography&width=800&height=450&seq=japan-academy-award&orientation=landscape",
    imageAlt: "苍井优在日本电影学院奖颁奖典礼上的照片",
    date: "2025-08-20",
    author: "编辑部",
    tags: ["日本电影学院奖", "获奖", "最佳女主角", "荣誉"],
    featured: true,
  },
  {
    id: "blue-ribbon-award",
    title: "蓝丝带奖——苍井优的演技再获认可",
    excerpt: "苍井优凭借精湛的演技再度获得蓝丝带奖的肯定。这个由东京电影记者协会颁发的奖项，见证了苍井优从新人到实力派的完整成长轨迹。",
    content: `<p>蓝丝带奖（ブルーリボン賞）是日本历史最悠久的电影奖项之一，由东京电影记者协会于1950年创立。苍井优与该奖项有着深厚的渊源——从2007年凭借《扶桑花女孩》获得最佳女主角奖开始，她已多次获得蓝丝带奖的提名和奖项。</p>
    <p>这一次，苍井优再次用实力证明了自己在电影界的地位。评审团表示，苍井优的表演"兼具深度与灵性，每一个角色在她的诠释下都焕发出独特的生命力"。这种评价对于一个出道二十余年的演员来说，既是肯定，也是鞭策。</p>
    <p>在颁奖典礼后的记者会上，苍井优谦逊地表示："奖项是一种鼓励，但不会改变我对表演的态度。每一个新角色都是一次新的挑战，我会继续努力，不辜负观众和评审的期待。"</p>`,
    category: "awards",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20Yu%20Aoi%20at%20film%20award%20ceremony%2C%20elegant%20attire%2C%20warm%20lighting%2C%20graceful%20smile%2C%20professional%20event%20photography%2C%20sophisticated%20atmosphere&width=800&height=450&seq=blue-ribbon-award&orientation=landscape",
    imageAlt: "苍井优在蓝丝带奖颁奖典礼上",
    date: "2025-07-15",
    author: "编辑部",
    tags: ["蓝丝带奖", "获奖", "电影", "荣誉"],
    featured: false,
  },
  {
    id: "yu-aoi-biography",
    title: "苍井优——从福冈走向世界的日本女演员",
    excerpt: "苍井优，1985年8月17日出生于日本福冈县。从小学开始接触表演，到成为日本影视界最具代表性的实力派女演员之一，苍井优的成长之路充满了坚持与热爱。",
    content: `<p>苍井优（Yu Aoi），1985年8月17日出生于日本福冈县福冈市。她从小便展现出对表演艺术的天赋和热爱。小学时期，苍井优开始参加儿童剧团的训练，这段经历为她日后的演艺事业打下了坚实的基础。</p>
    <p>1999年，年仅14岁的苍井优在音乐剧《安妮》中出演角色，正式以演员身份出道。2001年，她在电视剧《爱与青春的宝冢》中首次亮相电视荧幕，清新的形象和自然的表演引起了业界的关注。</p>
    <p>2006年是苍井优演艺生涯的转折点。她在电影《扶桑花女孩》中的出色表现让她一举成名，并获得了包括日本电影学院奖最佳女配角在内的多项大奖。此后，苍井优的演艺事业蒸蒸日上，在电影、电视剧和舞台剧三个领域都取得了卓越的成就。</p>
    <p>苍井优的表演风格独树一帜。她擅长用极其细腻的方式诠释角色的内心世界，被誉为"用眼神演戏的女演员"。无论是天真烂漫的少女、坚韧不拔的女性，还是复杂多面的角色，她都能够精准地捕捉到角色的灵魂所在。</p>
    <p>除了表演事业，苍井优还积极参与公益活动。她曾担任联合国儿童基金会日本委员会的大使，为改善儿童教育和福利做出了诸多贡献。她的优雅与智慧，不仅在银幕上闪耀，更在生活中温暖了无数人。</p>`,
    category: "biography",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20Yu%20Aoi%20elegant%20portrait%2C%20natural%20soft%20lighting%2C%20minimalist%20style%2C%20warm%20earthy%20color%20tones%2C%20clean%20background%2C%20artistic%20portrait%20photography&width=800&height=450&seq=yu-aoi-biography&orientation=landscape",
    imageAlt: "苍井优优雅的个人肖像照",
    date: "2025-06-10",
    author: "编辑部",
    tags: ["个人资料", "生平", "演艺生涯", "苍井优"],
    featured: false,
  },
  {
    id: "yu-aoi-acting-style",
    title: "解密苍井优的演技密码：克制中见力量",
    excerpt: "苍井优的演技为何能打动无数观众？本文深度分析她独特的表演风格——以克制为底色，在不动声色间释放出惊人的情感力量。",
    content: `<p>在日本演艺圈，苍井优的表演风格可以说是独树一帜。她不依赖夸张的表情和激烈的肢体动作，而是以一种近乎禅意的方式，将角色的情感内化于心、外化于形。这种"克制美学"成为了她最鲜明的表演标签。</p>
    <p>苍井优曾在采访中说过："我认为最好的表演是让观众忘记演员的存在，只看到角色本身。"为了实现这一目标，她在每个角色开拍前都会做大量的准备工作——阅读剧本数十遍、撰写角色小传、甚至亲自体验角色的生活方式。</p>
    <p>日本著名导演是枝裕和曾评价苍井优："她有一种罕见的能力，可以在镜头前完全放下自我。这种能力不是技巧，而是一种天赋与后天努力结合的结果。当她进入角色的时候，你会忘记她是一个演员，而是相信她就是那个活生生的人。"</p>
    <p>对于年轻演员来说，苍井优的表演哲学提供了宝贵的启示——真正的演技不在于外表的变化，而在于内心的深度。她用二十余年的演艺生涯证明了，安静的力量同样可以震撼人心。</p>`,
    category: "biography",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20close-up%20expressive%20portrait%2C%20soft%20natural%20window%20light%2C%20minimalist%20aesthetic%2C%20warm%20tones%2C%20contemplative%20mood%2C%20artistic%20black%20and%20white%20photography%20style&width=800&height=450&seq=yu-aoi-acting-style&orientation=landscape",
    imageAlt: "苍井优的表演艺术分析配图",
    date: "2025-05-25",
    author: "编辑部",
    tags: ["演技分析", "表演风格", "个人资料", "苍井优"],
    featured: false,
  },
  {
    id: "new-film-2025",
    title: "苍井优确认出演2026年重磅新片，与国际导演首次合作",
    excerpt: "最新消息！苍井优已确认将出演一部国际合拍电影，这也是她首次与享誉全球的国际导演合作，预计将于2026年上映。",
    content: `<p>据日本媒体最新报道，苍井优已确认将出演一部备受瞩目的国际合拍电影。这部作品由一位曾获得戛纳电影节金棕榈奖的国际知名导演执导，预计将于2026年底在全球范围内上映。</p>
    <p>据悉，苍井优在片中饰演一位具有复杂背景的女性角色。这个角色需要跨越多种语言和文化背景，对她来说是一次全新的挑战。为了准备这个角色，苍井优已经在积极学习外语，并深入研究角色的文化背景。</p>
    <p>该片的制作团队阵容豪华，除了国际导演外，还汇聚了来自日本、法国和美国的顶尖制作人员。业内人士认为，这部电影将成为苍井优走向国际舞台的重要里程碑。</p>
    <p>苍井优的经纪公司表示："苍井优对这个项目非常投入。这是一个能够展现她演技深度和广度的角色，也是她期待已久的国际合作机会。我们相信这部电影会给大家带来惊喜。"</p>`,
    category: "news",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20on%20international%20film%20set%2C%20professional%20movie%20production%20scene%2C%20warm%20cinematic%20lighting%2C%20elegant%20composition%2C%20modern%20film%20studio%2C%20artistic%20atmosphere&width=800&height=450&seq=new-film-2025&orientation=landscape",
    imageAlt: "苍井优新片拍摄现场照片",
    date: "2025-08-01",
    author: "编辑部",
    tags: ["最新动态", "新片", "国际合作", "2026"],
    featured: true,
  },
  {
    id: "charity-event",
    title: "苍井优出席联合国儿童基金会慈善晚宴",
    excerpt: "作为联合国儿童基金会日本委员会大使，苍井优近日出席了在东京举办的慈善晚宴，为改善全球儿童教育环境发声。",
    content: `<p>近日，苍井优以联合国儿童基金会（UNICEF）日本委员会大使的身份，出席了在东京举办的年度慈善晚宴。身着一袭素雅长裙的她，在晚宴上发表了感人至深的演讲，呼吁社会各界关注全球儿童的受教育权问题。</p>
    <p>"每一个孩子都有权利接受优质的教育，无论他们出生在哪里、家庭背景如何，"苍井优在演讲中说道，"作为公众人物，我有责任为那些无法发声的孩子们发声。"</p>
    <p>苍井优多年来一直积极参与UNICEF的各项公益活动。她曾亲自前往东南亚和非洲的一些贫困地区，了解当地儿童面临的实际困难，并通过自己的影响力为这些项目募集了大量善款。</p>
    <p>UNICEF日本委员会的代表对苍井优的贡献给予了高度评价："苍井优不仅是一位杰出的演员，更是一位充满爱心和责任感的公益大使。她的参与让更多人开始关注儿童权益问题。"</p>`,
    category: "news",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20at%20charity%20gala%20dinner%2C%20elegant%20dress%2C%20warm%20chandelier%20lighting%2C%20sophisticated%20event%20venue%2C%20graceful%20atmosphere%2C%20professional%20event%20photography&width=800&height=450&seq=charity-event&orientation=landscape",
    imageAlt: "苍井优在UNICEF慈善晚宴上",
    date: "2025-07-28",
    author: "编辑部",
    tags: ["最新动态", "慈善", "UNICEF", "公益活动"],
    featured: false,
  },
  {
    id: "tv-drama-2025",
    title: "苍井优将主演2026年春季档日剧，挑战全新角色类型",
    excerpt: "据日媒报道，苍井优已确定主演2026年春季档日剧。这次她将挑战一个此前从未尝试过的角色类型，令粉丝们充满期待。",
    content: `<p>日本电视台近日正式宣布，苍井优将主演2026年春季档日剧，这也是她时隔三年再次担任电视剧的主演。该剧改编自一部畅销小说，讲述了一位女性法医在破解案件的过程中，逐渐揭开自己身世之谜的故事。</p>
    <p>对于苍井优来说，法医这个角色是全新的挑战。她需要掌握大量的专业术语和动作细节，为此她已经在东京大学法医学教室进行了为期两个月的实地学习。制作人表示："苍井优的专业态度令人敬佩。她不仅记住了所有的医学术语，还能够将角色的专业性和人性化完美地结合起来。"</p>
    <p>该剧的编剧是曾创作过多部热门日剧的知名编剧，导演则由多次与苍井优合作的老搭档担任。这个黄金组合的再次联手，让业界对这部作品寄予了极高的期望。</p>
    <p>粉丝们在社交媒体上纷纷表示期待："苍井优演法医，太让人期待了！""已经等不及2026年春天了！"</p>`,
    category: "news",
    image: "https://readdy.ai/api/search-image?query=Japanese%20actress%20reading%20script%20in%20modern%20apartment%2C%20warm%20natural%20light%2C%20minimalist%20interior%2C%20creative%20atmosphere%2C%20soft%20color%20tones%2C%20editorial%20photography&width=800&height=450&seq=tv-drama-2025&orientation=landscape",
    imageAlt: "苍井优研读剧本的照片",
    date: "2025-07-10",
    author: "编辑部",
    tags: ["最新动态", "日剧", "2026春季档", "主演"],
    featured: false,
  },
];

export const featuredArticles = articles.filter((a) => a.featured);

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}